import React, { useState, FormEvent } from 'react';

import PageHeader from '../../components/PageHeader';
import TeacherItem, { Teacher } from '../../components/TeacherItem';
import Input from '../../components/Imput';
import Select from '../../components/Select';

import './styles.css';


function TeacherList() {
    const allTeachers: Teacher[] = [
        {
            avatar: "https://avatars.githubusercontent.com/u/62356988?v=4",
            bio: "Especialista em ecossistema JavaScript. Te ajudo a dominar React, Node.js e TypeScript do zero ao deploy. Vamos construir projetos reais que vão te destacar em processos seletivos e entender como as grandes stacks do mercado funcionam na prática.",
            cost: 90,
            id: 1,
            name: "Marlon Coimbra",
            subject: "Desenvolvimento Web Fullstack",
            whatsapp: "21981625423"
        },
        {
            avatar: "https://avatars.githubusercontent.com/u/62356988?v=4",
            bio: "Quer aprender a integrar o poder da IA nas suas aplicações? Minhas aulas focam em como utilizar APIs da OpenAI, LangChain e automações inteligentes. Ideal para desenvolvedores que querem subir de nível e criar soluções que parecem mágica, mas são pura engenharia.",
            cost: 120,
            id: 2,
            name: "Marlon Coimbra",
            subject: "Inteligência Artificial & LLMs",
            whatsapp: "21981625423"
        },
        {
            avatar: "https://avatars.githubusercontent.com/u/62356988?v=4",
            bio: "Programação não precisa ser um bicho de sete cabeças. Se você está travado no início da jornada, eu te ajudo a entender a lógica por trás do código. Foco total em fundamentos, resolução de problemas e algoritmos, sem termos complicados e com muita paciência.",
            cost: 75,
            id: 3,
            name: "Marlon Coimbra",
            subject: "Lógica de Programação com JavaScript",
            whatsapp: "21981625423"
        },
    ]

    const [teachers, setTeachers] = useState<Teacher[]>(allTeachers)
    const [subject, setSubject] = useState('')
    const [week_day, setWeek_day] = useState('')
    const [time, setTime] = useState('')

    async function seachTeacher(event: FormEvent) {
        event.preventDefault()

        let filtered = [...allTeachers]

        // Filtro por subject
        if (subject) {
            filtered = filtered.filter(teacher => {
                // Comparar pelo id da opção do select ou pelo subject direto
                if (subject === 'web_fullstack') return teacher.subject === 'Desenvolvimento Web Fullstack'
                if (subject === 'ai_llms') return teacher.subject === 'Inteligência Artificial & LLMs'
                if (subject === 'js_logic') return teacher.subject === 'Lógica de Programação com JavaScript'
                return false
            })
        }

        // Filtro por week_day - se domingo (0), retorna vazio
        if (week_day === '0') {
            filtered = []
        }

        setTeachers(filtered)
    }

    return (
        <div id="page-teacher-list" className="container">
            <PageHeader title="Esses são os proffys disponiveis.">
                <form id="search-teachers" onSubmit={seachTeacher}>
                    <Select
                        name="subject"
                        label="Matéria"
                        value={subject}
                        onChange={e => setSubject(e.target.value)}
                        options={[
                            { id: 'web_fullstack', label: 'Desenvolvimento Web Fullstack' },
                            { id: 'ai_llms', label: 'Inteligência Artificial & LLMs' },
                            { id: 'js_logic', label: 'Lógica de Programação com JavaScript' },
                            { id: 'mobile_react', label: 'Desenvolvimento Mobile (React Native)' },
                            { id: 'prompt_engineering', label: 'Engenharia de Prompt' },
                            { id: 'data_structures', label: 'Estrutura de Dados e Algoritmos' },
                        ]}
                    />
                    <Select
                        name="week-day"
                        label="Dia da semana"
                        value={week_day}
                        onChange={e => setWeek_day(e.target.value)}
                        options={[
                            { id: '0', label: 'Domingo' },
                            { id: '1', label: 'Segunda-feira' },
                            { id: '2', label: 'Terça-feira' },
                            { id: '3', label: 'Quarta-feira' },
                            { id: '4', label: 'Quinta-feira' },
                            { id: '5', label: 'Sexta-feira' },
                            { id: '6', label: 'Sábado' },
                        ]}
                    />
                    <Input
                        name="time"
                        label="Hora"
                        type="time"
                        value={time}
                        onChange={e => setTime(e.target.value)}
                    />

                    <button type="submit">
                        <i className="fas fa-search"></i>
                    </button>
                </form>
            </PageHeader>

            <main>
                {teachers.map((teacher: Teacher) => {
                    return <TeacherItem key={teacher.id} teacher={teacher} />
                })}

                {teachers.length === 0 && (
                    <div className="no-results">
                        <p>Nenhum proffy encontrado com esses filtros.</p>
                    </div>
                )}
            </main>
        </div>
    )
}

export default TeacherList;